<style lang="scss" scoped>

.bg-disabled {
    background-color: #F1F5F9 !important;
}

:deep(.row a)  {
    text-decoration: none;
    cursor: default;
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.5s ease;
}

.scale-enter-from,
.scale-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

</style>

<template>
    <transition name="scale">
    <div v-if="waterPoint" class="card" :title="disabled ? 'Festgelegter Brunnen': ''">
        <div class="list-group list-group-flush list-group-hoverable" :class="{'bg-disabled': disabled}" >
            <div v-if="!disabled" class="list-group-item">
                <router-link :to="routerTo" @click="$parent.closeModal">
                    <WaterPointItem :waterPoint="waterPoint">
                    </WaterPointItem>
                </router-link>
            </div>
            <div v-else class="list-group-item">
                <WaterPointItem :waterPoint="waterPoint">
                </WaterPointItem>
            </div>
        </div>
    </div>
    </transition>
    <div v-if="!waterPoint && !disabled">
        <router-link :to="routerTo" @click="$parent.closeModal">
            <div class="btn btn-white w-100">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-crop"
                width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="#00abfb" fill="none"
                stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 7c3 -2 6 -2 9 0s6 2 9 0" />
                    <path d="M3 17c3 -2 6 -2 9 0s6 2 9 0" />
                    <path d="M3 12c3 -2 6 -2 9 0s6 2 9 0" />
                </svg>
                Entnahmestelle wählen
            </div>
        </router-link>
    </div>
</template>

<script>
import axios from 'axios';

import WaterPointItem from '@/components/waterpoint/WaterPointItem.vue';

export default {
    name: 'WaterPointSelect',
    components: {
        WaterPointItem
    },
    inject: [
        'state',
        'config'
    ],
    props: {
        waterPointId: {
          type: Number,
          default: null
        },
        disabled: {
          type: Boolean,
          default: false
        },
        referrer: {
          type: String,
          default: null
        },
        updateOnChange: {
          default: null
        }    
    },
    data: function () {
        return {
            loading: false
        }
    },
    computed: { 
        waterPoint: function () {
            return this.state.actions.waterPoint.get(this.waterPointId);
        },
        globalWaterPointId: function () {
            return this.state.waterPoint.id;
        },
        routerTo: function () {
            const path = {path:'/waterpoints'};
            const query = { query: {referrer: encodeURIComponent(this.referrer)}}; 
            
            return Object.assign(path, query);
        }       
    },  
    methods: {
        setWaterPoint: function (waterPointId) { 
            let self = this;

            if (waterPointId) {
                if (self.state.actions.waterPoint.get(waterPointId)) {
                    self.$emit('update:waterPointId', parseInt(waterPointId));
                } else {
                    this.fetchData( function () { 
                        self.$emit('update:waterPointId', parseInt(waterPointId));
                    })
                }
            } else if (self.globalWaterPointId) {
                this.$emit('update:waterPointId', parseInt(self.globalWaterPointId));
            }
        },
        fetchData: function (callback) {
            
            let self = this;
                       
            let query = {
                query: `
                    query ($withdrawalYear: Int) {
                        waterPoints (withdrawalYear: $withdrawalYear){
                            id
                            label
                            typ
                            latitude
                            longitude
                            maxWithdrawal
                            gaugeMark
                            gaugeMarkPosition
                            totalWithdrawal
                            lastStillWaterLevel
                        }
                        loggedIn
                    }
                `,      
                variables: {
                    withdrawalYear: self.state.profile.item() ? self.state.profile.item().year: null
                } 
            }
            
            let request = Object.assign({}, self.config.request);
            request["data"] = query;
            
            self.loading = true;
            
            axios(request).then( function (response) {
                let data = response.data.data;
                
                // alert(JSON.stringify(data));
            
                if ( data !== null ) {
                    self.state.actions.waterPoint.setList(data.waterPoints);
                } else {
                    console.log(data);    
                }
            
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                 if (callback) {
                    callback(self);
                }
                
            });
        }
    },
    watch: {        
        waterPointId: function (new_value, old_value) {      
            if ( new_value !== old_value ) {            
                this.setWaterPoint(new_value);
            }
        },
        updateOnChange: function () { 
            let self = this;
            this.fetchData( function () { 
                self.waterPoint = self.state.actions.waterPoint.get(self.waterPointId);
            })
        }
    },
    mounted: function () {
        this.setWaterPoint(this.waterPointId);
    }
}

</script>